export default __webpack_public_path__ + "static/media/sa-img.44ab915e.webp";